var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"question-icon"},[_c('img',{ref:"questionIcon",attrs:{"src":`icons/icn-${_vm.isBlack ? 'negra' : 'blanca-02'}.svg`,"alt":"info"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }